import { Button } from '@mui/material';

type Props = {
  isRunMode: boolean;
  label?: string;
  isTriplexPump: boolean;
  isQuadroplexPump?: boolean;
  isMobile?: boolean;
};

export const PumpModeLabel = ({
  isRunMode,
  label,
  isTriplexPump,
  isQuadroplexPump,
  isMobile,
}: Props) => (
  <Button
    sx={{
      isplay: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: isTriplexPump ? (isMobile ? '20px' : '30px') : isMobile ? '20px' : '36px',
      height: 'auto',
      whiteSpace: isQuadroplexPump || isTriplexPump ? 'normal' : 'nowrap',
      background: isRunMode ? 'rgba(5, 182, 178, 0.08)' : 'rgba(145, 158, 171, 0.08)',
      borderRadius: '8px',
      fontFamily: 'Public Sans',
      fontStyle: 'normal',
      fontWeight: label === 'Off' ? 600 : 700,
      fontSize: isMobile ? '9px' : isTriplexPump || isQuadroplexPump ? '10px' : '12px',
      lineHeight: isMobile ? '12px' : '24px',
      minWidth: isTriplexPump ? '30px' : '40px',
      width: isQuadroplexPump && isMobile ? '47px' : undefined,
      wordBreak: isQuadroplexPump || isTriplexPump ? 'break-word' : 'normal',
      color: isRunMode ? '#05B6B2' : '#212B36',
      padding: isMobile ? '3px 5px' : isQuadroplexPump || isTriplexPump ? '1px 4px' : '3px 8px',
      margin: isQuadroplexPump || isTriplexPump || isMobile ? '0 2px' : '0 1rem',
      '&:hover': {
        cursor: 'pointer',
        background: isRunMode ? 'rgba(5, 182, 178, 0.08)' : 'rgba(145, 158, 171, 0.08)',
        boxShadow: isRunMode
          ? '0 8px 16px 0 rgba(5, 182, 178, 0.24)'
          : '0 8px 16px 0 rgba(145, 158, 171, 0.08)',
      },
    }}
  >
    {label}
  </Button>
);
